import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import {constants} from 'src/environments/constants';
import { DataService } from './data.service';
import { InsightDataService } from './insight/insight-data.service';
import { MockDataService } from './mock-data.service';
import { CdwDataService } from './cdw/cdw-data.service';
import { SynnexDataService } from './synnex/synnex-data.service';
import { ConnectionDataService } from './connection/connection-data.service';
import { TraferaDataService } from './trafera/trafera-data.service';

@Injectable({
  providedIn: 'root'
})
export class DataFactoryService {

  constructor(private injector: Injector) { }

  getDataService(): DataService {
    switch (environment.name) {
      case constants.SANDBOX:
        return this.injector.get(MockDataService);
      case constants.INSIGHT:
      case constants.INSIGHT_EDU:
      case constants.DEMO:
      case constants.DEMO_EDU:
      case constants.DEFAULT:
        return this.injector.get(InsightDataService);
      case constants.CDW:
        return this.injector.get(CdwDataService);
      case constants.SYNNEX:
        return this.injector.get(SynnexDataService);
      case constants.SYNNEX_Public:
        return this.injector.get(SynnexDataService);
      case constants.CONNECTION:
        return this.injector.get(ConnectionDataService);
      case constants.CONNECTION_GOV:
        return this.injector.get(ConnectionDataService);
      case constants.TRAFERA:
        return this.injector.get(TraferaDataService);
      default:
        return this.injector.get(MockDataService);
    }
  }
}
